module.exports = __webpack_public_path__ + "img/home_header_lg.7284d027.png";